// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"45d64f18","408":"0d368646","423":"36b3259f","658":"70050770","773":"a9cb21a2","972":"d49bfffe"}[chunkId] + ".chunk.js";
};